import { DatePicker } from "@/core/components/DatePicker/DatePicker";
import { Box } from "@mui/material";
import { BannerProps } from "@/core/types/types";

const PartialFlowHeader = ({
  originAirportData,
  destinationAirportData,
  selectedFlightDate,
  setSelectedFlightDate,
}: BannerProps) => (
  <Box
    my={2}
    sx={{
      display: "flex",
      justifyContent: "space-between",
    }}
  >
    <h2>
      {originAirportData.iata} ➡ {destinationAirportData.iata}
    </h2>

    <DatePicker
      value={selectedFlightDate ? selectedFlightDate : ""}
      onPreviousDateSelect={setSelectedFlightDate}
      onNextDateSelect={setSelectedFlightDate}
    />
  </Box>
);

export default PartialFlowHeader;
